

var isOnline = location.host.indexOf('chmelk.com') != -1;
var baseUrl = isOnline ? '//api.chmelk.com/index.php?r=' : '//api.chmelk.com/index.php?r=';
var baseHomeUrl = isOnline ? 'http://chmelk.com' : 'http://change.cc';

export default {
    apiHost: baseUrl,
    baseHomeUrl:baseHomeUrl
}



// WEBPACK FOOTER //
// ./src/config.js